import script from "./_form.vue?vue&type=script&setup=true&lang=js"
export * from "./_form.vue?vue&type=script&setup=true&lang=js"

import "./_form.vue?vue&type=style&index=0&id=7812fef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7812fef0"]])

export default __exports__